import { useEffect, useRef, useCallback } from "react";

const SNAP_JS_SANDBOX = "https://app.sandbox.midtrans.com/snap/snap.js";
const SNAP_JS_PROD = "https://app.midtrans.com/snap/snap.js";

/**
 * Loads the Midtrans Snap JS script once. Returns a `pay(token, handlers)` function.
 * Usage:
 *   const pay = useMidtransSnap(clientKey, isProd);
 *   pay(token, { onSuccess, onPending, onError, onClose });
 */
export function useMidtransSnap(clientKey, isProduction = false) {
  const readyRef = useRef(false);

  useEffect(() => {
    if (!clientKey) return;
    const id = "midtrans-snap-js";
    const existing = document.getElementById(id);
    if (existing) { readyRef.current = true; return; }
    const s = document.createElement("script");
    s.id = id;
    s.src = isProduction ? SNAP_JS_PROD : SNAP_JS_SANDBOX;
    s.setAttribute("data-client-key", clientKey);
    s.async = true;
    s.onload = () => { readyRef.current = true; };
    document.body.appendChild(s);
  }, [clientKey, isProduction]);

  const pay = useCallback((token, handlers = {}) => {
    if (!token) return;
    if (typeof window === "undefined" || !window.snap) {
      // Retry after a short delay
      setTimeout(() => { if (window.snap) window.snap.pay(token, handlers); }, 500);
      return;
    }
    window.snap.pay(token, handlers);
  }, []);

  return pay;
}

export function formatRupiah(n) {
  if (n == null) return "-";
  return "Rp " + Number(n).toLocaleString("id-ID");
}
